<div class="p-10" fxLayout="row" fxLayoutAlign="space-between center">
    
    <div class="expenses-list-panel">

        <div class="table-header-row p-b-10">
            <div class="widget" fxFlex="100" fxFlex.gt-sm="100">
                <div class="p-t-10" fxLayout="row" fxLayoutAlign="space-between center">
                    <div class="expenses-month">
                        <app-expenses-date></app-expenses-date>
                    </div>
                    <div>
                        <app-expenses-header></app-expenses-header>
                    </div>
                </div>
            </div>
        </div>
        <div >

            <div class="p-10" *ngIf="monthlyExpensesService.expensesList.data.length === 0 && !monthlyExpensesService.isListLoading">
                <p>No se encontraron registros</p>
            </div>
        
            <div *ngIf="monthlyExpensesService.isListLoading" class="m-auto">
                <mat-progress-spinner class="m-auto" [diameter]="50" color="primary" mode="indeterminate">
                </mat-progress-spinner>
            </div>

            <div class="expenses-list-scroll" *ngIf="monthlyExpensesService.expensesList.data.length > 0 && !monthlyExpensesService.isListLoading">
                <table mat-table matSort [dataSource]="monthlyExpensesService.expensesList" class="mat-elevation-z8 "
                    #expensesList id="expenses-list">
                    <caption></caption>

                    <ng-container matColumnDef="action" class="except">
                        <th id="actions" mat-header-cell *matHeaderCellDef> </th>
                        <td mat-cell *matCellDef="let exp" class="text-right except expenses-list-panel-icons">

                            <button mat-icon-button [matMenuTriggerFor]="appMenu" class="except"> 
                                <mat-icon class="except">more_vert</mat-icon>
                            </button>
                    
                            <mat-menu #appMenu="matMenu" class="except">
                                <button class="except" mat-menu-item (click)="repercutir(exp)" *ngIf="exp.traspasado === 'N'">
                                    <mat-icon class="mat-icon material-icons mat-icon-no-color except" role="img" aria-hidden="true">publish</mat-icon> 
                                    Repercutir
                                </button>
                                <button class="except" mat-menu-item (click)="deshacerTraspasoRecord(exp.id)" *ngIf="exp.traspasado === 'S'">
                                    <mat-icon class="mat-icon material-icons mat-icon-no-color except" role="img" aria-hidden="true">
                                    undo </mat-icon> Deshacer traspaso
                                </button>
                            </mat-menu>

                            <div *ngIf="exp.traspasado !== 'S'">
                                <button *ngIf="exp.isEditing === undefined || !exp.isEditing"
                                    mat-icon-button class="except" (click)="toggleRowEdit(exp, true)"> 
                                    <mat-icon class="except">edit</mat-icon>
                                </button>

                                <div *ngIf="exp.isEditing !== undefined && exp.isEditing">
                                    <button mat-icon-button class="except" (click)="updateRow(exp)"> 
                                        <mat-icon class="except blue-grey-fg ">check</mat-icon>
                                    </button>
                                    <button mat-icon-button class="except" (click)="clearRowChanges()"> 
                                        <mat-icon class="except color-red">close</mat-icon>
                                    </button>
                                </div>
                            </div>
                            
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="medico">
                        <th id="medico" mat-header-cell *matHeaderCellDef mat-sort-header> Medico </th>
                        <td mat-cell *matCellDef="let exp">
                            {{ exp.medico | titlecase }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="empresa">
                        <th id="empresa" mat-header-cell *matHeaderCellDef mat-sort-header> Empresa </th>
                        <td mat-cell *matCellDef="let exp"> {{ exp.empresa | titlecase }} </td>
                    </ng-container>

                    <ng-container matColumnDef="fijoKm">
                        <th id="fijoKm" mat-header-cell *matHeaderCellDef mat-sort-header> Fijo Km </th>
                        <td mat-cell *matCellDef="let exp">
                            <mat-form-field>
                                <input type="text" matInput appOnlyNumbers
                                    (ngModelChange)="exp.fijoKm=$event" 
                                    [ngModel]="exp.fijoKm | spanishNumber" 
                                    [value]="exp.fijoKm | spanishNumber" 
                                    [readonly]="exp.traspasado !== 'N' || (exp.isEditing === undefined || !exp.isEditing)"
                                    [ngModelOptions]="{updateOn:'blur'}"
                                    autocomplete="off">
                                <span *ngIf="exp.fijoKm !== null && exp.fijoKm !== 0" matPrefix>€</span>
                            </mat-form-field>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="km">
                        <th id="km" mat-header-cell *matHeaderCellDef mat-sort-header> Kms </th>
                        <td mat-cell *matCellDef="let exp"> 
                            <mat-form-field>
                                <input type="number" matInput [(ngModel)]="exp.km" 
                                    [value]="exp.km" 
                                    [readonly]="exp.traspasado !== 'N' || (exp.isEditing === undefined || !exp.isEditing)" 
                                    [ngModelOptions]="{updateOn:'blur'}"
                                    autocomplete="off"
                                    (blur)="calculateField(exp, 'Km', true)">
                            </mat-form-field>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="precioKm">
                        <th id="precioKm" mat-header-cell *matHeaderCellDef mat-sort-header> €/Km </th>
                        <td mat-cell *matCellDef="let exp">
                            <mat-form-field>
                                <input type="text" matInput appOnlyNumbers
                                    (ngModelChange)="exp.precioKm=$event"
                                    [ngModel]="exp.precioKm | spanishNumber" 
                                    [value]="exp.precioKm | spanishNumber" 
                                    [readonly]="exp.traspasado !== 'N' || (exp.isEditing === undefined || !exp.isEditing)"
                                    [ngModelOptions]="{updateOn:'blur'}"
                                    autocomplete="off"
                                    (blur)="calculateField(exp, 'Km')">
                                <span *ngIf="exp.precioKm !== null && exp.precioKm !== 0" matPrefix>€</span>
                            </mat-form-field>
                        </td>
                    </ng-container>


                    <ng-container matColumnDef="totalKm">
                        <th id="totalKm" mat-header-cell *matHeaderCellDef mat-sort-header> Total Km </th>
                        <td mat-cell *matCellDef="let exp"> 
                            <span *ngIf="exp.totalKm !== null && exp.totalKm !== 0">€</span>
                            <span>{{ exp.totalKm | spanishNumber }} </span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="horas">
                        <th id="horas" mat-header-cell *matHeaderCellDef mat-sort-header> Horas </th>
                        <td mat-cell *matCellDef="let exp">
                            <mat-form-field>
                                <input type="text" matInput appOnlyNumbers
                                    (ngModelChange)="exp.horas=$event"
                                    [ngModel]="exp.horas | spanishNumber : true" 
                                    [value]="exp.horas | spanishNumber : true" 
                                    [readonly]="exp.traspasado !== 'N' || (exp.isEditing === undefined || !exp.isEditing)" 
                                    [ngModelOptions]="{updateOn:'blur'}"
                                    autocomplete="off"
                                    (blur)="calculateField(exp, 'Hora', true)">
                            </mat-form-field>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="precioHora">
                        <th id="precioHora" mat-header-cell *matHeaderCellDef mat-sort-header> €/hora </th>
                        <td mat-cell *matCellDef="let exp">
                            <mat-form-field>
                                <input type="text" matInput appOnlyNumbers
                                    (ngModelChange)="exp.precioHora=$event"
                                    [ngModel]="exp.precioHora | spanishNumber" 
                                    [value]="exp.precioHora | spanishNumber" 
                                    [readonly]="exp.traspasado !== 'N' || (exp.isEditing === undefined || !exp.isEditing)"
                                    [ngModelOptions]="{updateOn:'blur'}"
                                    autocomplete="off"
                                    (blur)="calculateField(exp, 'Hora')"> 
                                <span *ngIf="exp.precioHora !== null && exp.precioHora !== 0" matPrefix>€</span>
                            </mat-form-field>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="totalHora">
                        <th id="totalHora" mat-header-cell *matHeaderCellDef mat-sort-header> Total Horas </th>
                        <td mat-cell *matCellDef="let exp">
                            <span *ngIf="exp.totalHora !== null && exp.totalHora !== 0">€</span>
                            <span>{{ exp.totalHora | spanishNumber }}</span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="dias">
                        <th id="dias" mat-header-cell *matHeaderCellDef mat-sort-header> Días </th>
                        <td mat-cell *matCellDef="let exp">
                            <mat-form-field>
                                <input type="text" matInput appOnlyNumbers
                                    (ngModelChange)="exp.dias=$event"
                                    [ngModel]="exp.dias | spanishNumber : true" 
                                    [value]="exp.dias | spanishNumber : true" 
                                    [value]="exp.dias" 
                                    [readonly]="exp.traspasado !== 'N' || (exp.isEditing === undefined || !exp.isEditing)"
                                    [ngModelOptions]="{updateOn:'blur'}"
                                    autocomplete="off"
                                    (blur)="calculateField(exp, 'Dia', true)">
                            </mat-form-field>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="precioDia">
                        <th id="precioDia" mat-header-cell *matHeaderCellDef mat-sort-header> €/día </th>
                        <td mat-cell *matCellDef="let exp">
                            <mat-form-field>
                                <input type="text" matInput appOnlyNumbers
                                    (ngModelChange)="exp.precioDia=$event"
                                    [ngModel]="exp.precioDia | spanishNumber"
                                    [value]="exp.precioDia | spanishNumber" 
                                    [readonly]="exp.traspasado !== 'N' || (exp.isEditing === undefined || !exp.isEditing)"
                                    [ngModelOptions]="{updateOn:'blur'}"
                                    autocomplete="off"
                                    (blur)="calculateField(exp, 'Dia')">
                                <span *ngIf="exp.precioDia !== null && exp.precioDia !== 0" matPrefix>€</span>
                            </mat-form-field>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="totalDias">
                        <th id="totalDias" mat-header-cell *matHeaderCellDef mat-sort-header> Total Días </th>
                        <td mat-cell *matCellDef="let exp"> 
                            <span *ngIf="exp.totalDias !== null && exp.totalDias !== 0">€</span>
                            <span>{{ exp.totalDias | spanishNumber }}</span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="fijoMes">
                        <th id="fijoMes" mat-header-cell *matHeaderCellDef mat-sort-header> Fijo Mes </th>
                        <td mat-cell *matCellDef="let exp">
                            <mat-form-field>    
                                <input type="text" matInput appOnlyNumbers
                                    (ngModelChange)="exp.fijoMes=$event" 
                                    [ngModel]="exp.fijoMes | spanishNumber"
                                    [value]="exp.fijoMes | spanishNumber" 
                                    [readonly]="exp.traspasado !== 'N' || (exp.isEditing === undefined || !exp.isEditing)"
                                    [ngModelOptions]="{updateOn:'blur'}"
                                    autocomplete="off">
                                <span *ngIf="exp.fijoMes !== null && exp.fijoMes !== 0" matPrefix>€</span>
                            </mat-form-field>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="getDisplayedColumns(); sticky: true"></tr>
                    <tr [ngClass]="{'not-editable': exp.traspasado === 'S', 'read-only': exp.traspasado === 'N' && (exp.isEditing === undefined || !exp.isEditing) }" 
                        mat-row *matRowDef="let exp; columns: getDisplayedColumns();"></tr>
                </table>
            </div>
        </div>
        <div class="widget">
            <mat-paginator [pageSize]="10" [pageSizeOptions]="[10, 50, 100]">
            </mat-paginator>
        </div>
    </div>
</div>